// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BpFiltersController from "./bp_filters_controller"
application.register("bp-filters", BpFiltersController)

import BpiController from "./bpi_controller"
application.register("bpi", BpiController)

import BqiController from "./bqi_controller"
application.register("bqi", BqiController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MultiuploadController from "./multiupload_controller"
application.register("multiupload", MultiuploadController)

import PbqController from "./pbq_controller"
application.register("pbq", PbqController)

import SurveyController from "./survey_controller"
application.register("survey", SurveyController)
